<template>
  <div>
    {{items}}
  </div>
</template>
<script>
import Api from '@/api/Statistic.js'
import {collectionMixin} from '@/components/mixins/Collection'

let structure = []

export default {
  mixins: [collectionMixin],
  data(){
    return {
      model: "statistics",
      api: new Api(),
      collectionData: structure,
      button: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// Statistics.vue?50c16bc9